// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2Ortx","button_white":"style_button_white__2y0IR","button_disabled":"style_button_disabled__355GC"};